import React, { useRef, useState, useImperativeHandle } from "react";
import ModalView from '@/components/modal-view'
import styled from "styled-components";
import ModalBG from '../imgs/common-modal-bg@2x.png';
import TipText from '../imgs/tip-text@2x.png';
import LinkBtn from '../imgs/link-btn@2x.png';
import CancelBtn from '../imgs/cancel-btn@2x.png';
import ConfirmBtn from '../imgs/confirm-btn@2x.png';
import { handleUploadTrace } from '../stock';

const ModalTips = React.forwardRef(({isConfirm}, ref) => {
  const [showModal, setShowModal] = useState(false);
  const modalContent = useRef(null);

  const options =  modalContent.current || {};

  useImperativeHandle(ref, () => {
    return {
      show: (opt) => {
        modalContent.current = opt;
        setShowModal(true);
      },
      close: () => setShowModal(false),
    }
  });

  const handleLinkApp = () => {
    /** */
    handleUploadTrace('download-app', 'click');
    
    setShowModal(false);
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  return (
    <ModalView
      visible={showModal}
      onClose={() => setShowModal(false)}
      content={
        <ModalWrap>
          <div className="modal-content">
            <div className="flex-center">
              {options.title || <img alt="" src={TipText} className="tip-text-img"/>}
            </div>
            <div className="tip-text">
              {options.content}
            </div>
            {
              options.isConfirm ? 
              <div className="confirm-wrap flex-center">
                <img onClick={() => setShowModal(false)} src={ConfirmBtn} alt="" className="confirm-btn" />
              </div> :
              <div className="btn-wrap">
                <div className="flex-center">
                  <img onClick={handleLinkApp} src={options.confirmBtn || LinkBtn} alt="" className="link-btn"/>
                </div>
                <div className="flex-center cancel-btn-wrap">
                  <img onClick={() => setShowModal(false)} src={CancelBtn} alt="" className="cancel-btn"/>
                </div>
              </div>
            }
            
          </div>
        </ModalWrap>
      }
    />
  )
})

const ModalWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 27px;
  color: #333;
  .modal-content {
    position: relative;
    border-radius: 10px;
    padding: 60px 0 35px;
    background-image: url(${ModalBG});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .tip-text {
    padding: 0 28px;
    text-align: center;
    font-size: 17px;
    font-weight: 400;
    color: #000000;
    line-height: 17px;
    margin-top: 12px;
  }
  .tip-text-img {
    width: 223px;
    height: 23px;
  }
  .link-btn {
    width: 173px;
    height: 46px;
  }
  .cancel-btn {
    width: 172px;
    height: 46px;
  }
  .cancel-btn-wrap {
    margin-top: 19px;
  }
  .confirm-wrap {
    margin-top: 33px;
  }
  .confirm-btn {
    width: 138px;
    height: 46px;
  }
  .btn-wrap {
    margin-top: 24px;
  }
`

export default React.memo(ModalTips);




// WEBPACK FOOTER //
// ./src/views/activity_31/components/modal-tips.js